import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import { ActiveInactive_Record, delete_Record } from "../CommonFunctions";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import {
  POST_GetDocumentManagementList,
  POST_DocumentManagementActiveInActive,
  POST_DocumentManagementDelete,
  POST_GetDocumentManagementViewHistory,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const DocumentManagement = () => {
  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "document-management" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "document-management" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "document-management" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "document-management" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);
  const [documentManagementList, setDocumentManagementList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [
    documentManagementReviseHistoryList,
    setDocumentManagementReviseHistoryList,
  ] = useState([]);
  const [
    documentManagementReviseHistoryModal,
    setDocumentManagementReviseHistoryModal,
  ] = useState(false);

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Search:
        filter && filter?.page == "document-management" ? filter?.Search : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search },
  } = formikFilter;

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "document-management",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Search: Search ? Search : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };
    await post(POST_GetDocumentManagementList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setDocumentManagementList(response?.List);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const DocumentManagement_History = (
    DocumentManagementID,
    ParentDocumentManagementID
  ) => {
    setIsLoading(true);
    setDocumentManagementReviseHistoryList("");
    setDocumentManagementReviseHistoryModal(true);

    let payload = {
      DocumentManagementIDEncrypted: DocumentManagementID,
      ParentDocumentManagementIDEncrypted: ParentDocumentManagementID,
    };
    post(POST_GetDocumentManagementViewHistory, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          setDocumentManagementReviseHistoryList(response?.List);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Document Management</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>

                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 87 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="/add-document-management"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa-solid fa-plus"></i> Add Document Management
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                            autoFocus={isFilterExpanded}
                          />
                        </Col>

                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                className="btn btn-primary btn-sm mb-1"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i className="fa fa-search" aria-hidden="true"></i>
                                {"  "} Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="Machines-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="Machines-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="10%"></th>
                      <th
                        style={{
                          width: "30%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("DocumentName");
                        }}
                      >
                        Document Name
                        <span className="ml-1">
                          {sortBy == "DocumentName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "20%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("CreatedDate");
                        }}
                      >
                        Created Date
                        <span className="ml-1">
                          {sortBy == "CreatedDate" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>

                      <th
                        style={{
                          width: "40%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("Description");
                        }}
                      >
                        Description
                        <span className="ml-1">
                          {sortBy == "Description" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentManagementList?.length > 0 ? (
                      documentManagementList?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 87 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/edit-document-management/${window.btoa(
                                  item?.DocumentManagementIDEncrypted
                                )}`}
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 87 && x?.IsActive
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                className={`icon-box icon-box-md me-1`}
                                title={
                                  item?.IsActive == true ? "Active" : "Inactive"
                                }
                                onClick={() => {
                                  ActiveInactive_Record(
                                    item?.IsActive,
                                    POST_DocumentManagementActiveInActive,
                                    {
                                      DocumentManagementIDEncrypted:
                                        item?.DocumentManagementIDEncrypted,
                                      IsActive: !item.IsActive,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item?.DocumentName
                                  );
                                }}
                              >
                                <i
                                  className={`fa fa-circle fs-15 ${
                                    item.IsActive == true
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                ></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 87 && x?.IsDelete
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                onClick={() => {
                                  delete_Record(
                                    POST_DocumentManagementDelete,
                                    {
                                      DocumentManagementIDEncrypted:
                                        item?.DocumentManagementIDEncrypted,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item?.DocumentName
                                  );
                                }}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 87 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/revise-document-management/${window.btoa(
                                  item?.DocumentManagementIDEncrypted
                                )}`}
                                className="icon-box icon-box-md me-1"
                                title="Revise"
                              >
                                <i className="fa fa-refresh"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            {item?.ParentDocumentManagementIDEncrypted ? (
                              <Link
                                className="icon-box icon-box-md me-1"
                                title="Revise History"
                                onClick={() => {
                                  DocumentManagement_History(
                                    item?.DocumentManagementIDEncrypted,
                                    item?.ParentDocumentManagementIDEncrypted
                                  );
                                }}
                              >
                                <i className="fa fa-history"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            {item?.DocumentManagementFilePath ? (
                              <Link
                                to="#"
                                className="fs-14"
                                title="Download"
                                onClick={() => {
                                  window.open(
                                    item?.DocumentManagementFilePath,
                                    "_blank"
                                  );
                                }}
                              >
                                {SVGICON.Download}
                              </Link>
                            ) : (
                              ""
                            )}
                          </td>
                          <td> {item?.DocumentName}</td>
                          <td> {item?.CreatedDate}</td>
                          <td style={{ textAlign: "left" }}>
                            {item?.Description}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={documentManagementReviseHistoryModal}
          onHide={setDocumentManagementReviseHistoryModal}
          size="xl"
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div>
              <Modal.Header>
                <Modal.Title>Document Management Revise History</Modal.Title>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() =>
                      setDocumentManagementReviseHistoryModal(false)
                    }
                  ></button>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="table-responsive active-projects style-1 shorting">
                  <div
                    id="Document-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="Document-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead className="thead-light">
                        <tr role="row">
                          <th style={{ width: "5%" }}>Sr No</th>
                          <th style={{ width: "20%" }}>Document Name</th>
                          <th style={{ width: "20%" }}>Created Date</th>
                          <th style={{ width: "25%" }}>File Name</th>
                          <th style={{ width: "15%" }}>Current Version</th>
                          <th style={{ width: "15%", textAlign: "left" }}>
                            View File
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {documentManagementReviseHistoryList?.length > 0 ? (
                          documentManagementReviseHistoryList?.map(
                            (item, indx) => (
                              <>
                                <tr role="row" className="odd">
                                  <td style={{ textAlign: "center" }}>
                                    {indx + 1}
                                  </td>
                                  <td>{item?.DocumentName}</td>
                                  <td>{item?.CreatedDate}</td>
                                  <td>{item?.DocumentManagementFileName}</td>
                                  <td>
                                    {item?.IsCurrentVersion ? "Yes" : "No"}
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item?.DocumentManagementFilePath
                                            ? item?.DocumentManagementFilePath
                                            : "",
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Link>
                                  </td>
                                </tr>
                              </>
                            )
                          )
                        ) : (
                          <tr>
                            <td
                              colSpan={4}
                              style={{
                                textAlign: "left",
                              }}
                            >
                              <div className="mt-1 ml-1 mb-2">
                                {"No Record Found..."}
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Modal.Body>
            </div>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default DocumentManagement;
